import { INavigation } from "src/app/models/navigation";

export const NAVIGATION_LIST: INavigation[] = [
    {
        name: 'Dashboard',
        route: 'dashboard',
        icon: 'dashboard'
    },
    
    {
        name: 'Bookings',
        route: 'messages',
        icon: 'message'
    },
    // {
    //     name: 'Platform Services',
    //     route: 'platform-services',
    //     icon: 'bolt'
    // },
    {
        name: 'Services',
        route: 'notifications',
        icon: 'notifications_active'
    },
    
    {
        name: 'Service hours',
        route: 'purchased-plans',
        icon: 'subscriptions'
    },
    
    {
        name: 'Employees',
        route: 'support',
        icon: 'contact_support'
    },
    
    
    {
        name: 'Recharges',
        route: 'privacy-policy',
        icon: 'lock'
    },
    {
        name: 'Contact us',
        route: 'terms-of-service',
        icon: 'description'
    },
    
    {
        name: 'Download app',
        route: 'download-app',
        icon: 'download'
    },
    {
        name: 'Refer a friend',
        // name: 'Share a friend',
        route: 'invite-friends',
        icon: 'share'
    },
    {
        name: 'Version 1.0.0',
        route: 'invite-friends',
        icon: 'share'
    }

]